import { InlineEdit } from "@/shared/components/EntityPage";
import { type DeviceTypeRecord } from "@/shared/domain/deviceTypes";
import { useUpdateDeviceType } from "@/shared/domain/deviceTypes/hooks";

/**
 * The type's description as Markdown, edited in place like a resource
 * page's description: ⌘↵ or clicking away saves, Esc restores it, and an
 * emptied one is cleared.
 */
export function EditableDeviceTypeDescription({
  deviceType,
}: {
  deviceType: DeviceTypeRecord;
}) {
  const { mutateAsync: updateDeviceType } = useUpdateDeviceType();
  return (
    <InlineEdit
      value={deviceType.description ?? ""}
      onSave={(description) =>
        updateDeviceType({
          deviceTypeId: deviceType.device_type_id,
          resourceOwnerId: deviceType.org_id,
          updates: { description: description || null },
        })
      }
      multiline
      placeholder="No description"
      textStyle="body"
      ariaLabel="device type description"
    />
  );
}
